import { S3_MP4_URL } from '../../../constants';

export const CARDS_DATA = [
  {
    id: 1,
    title: 'Get back up to 5%',
    description: 'in Solar Cash on stay bookings',
    video: `${S3_MP4_URL}how_it_works_1.mp4`,
  },
  {
    id: 2,
    title: '1 SC = 1 USD',
    description: 'Applicable for booking stays',
    video: `${S3_MP4_URL}how_it_works_2.mp4`,
  },
  {
    id: 3,
    title: 'Cover up to 100%',
    description: 'of your stay with bonuses',
    video: `${S3_MP4_URL}how_it_works_3.mp4`,
    video_mobile: `${S3_MP4_URL}how_it_works_mobile_3.mp4`,
  },
];
